import { LayoutAdminTable } from 'app/components/templates/LayoutAdminTable';
import React from 'react';
import { FileForm } from 'app/pages/Admin/FilesPage/components/FileForm';
import { useInjection } from './hook';
import { useNavigate, useParams } from 'react-router-dom';
import { DialogConfirm } from 'app/components/elements/DialogConfirm';
import { StorageServices } from 'services/storage';
import { Stack } from '@mui/material';
import { widthScreen } from 'const/common';
const storage = new StorageServices();

export const EditFilesPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const isMobile = widthScreen <= 765;
  const role = storage.getRole();
  const {
    asyncUpdateFile,
    reloadPage,
    leads,
    handleAddNewLead,
    handleAddNewNote,
    handleEditNote,
    file,
    handleDeleteLead,
    handleDeleteFile,
    showModalDeleteFile,
    setShowModalDeleteFile,
    showModalDeleteLead,
    setShowModalDeleteLead,
    setIdLeadDelete,
    handleAddTowYards,
    handleDeleteTowYards,
    handleChangeVinStatus,
    handleUploadFileCarfax,
    handleDeleteDocumentLead,
    optionClient,
    optionClientChild,
    optionAuctionDeliveryLocation,
    changeOptionClient,
    handleCloseClient,
    handleCloseNotFound,
    handleDeleteNoteLead,
    handleChooseRuleOut,
    handleRemindLead,
    handleOnHoldFile
  } = useInjection();

  return role === 'USER' && !isMobile ? (
    <Stack width={'100%'} mt={'20px'}>
      <FileForm
        handleChooseRuleOut={handleChooseRuleOut}
        handleRemindLead={handleRemindLead}
        reloadPage={reloadPage}
        handleOnHoldFile={handleOnHoldFile}
        handleDeleteNoteLead={handleDeleteNoteLead}
        optionClient={optionClient}
        optionClientChild={optionClientChild}
        optionAuctionDeliveryLocation={optionAuctionDeliveryLocation}
        changeOptionClient={changeOptionClient}
        initFile={file}
        createForm={asyncUpdateFile}
        isEdit
        leads={leads}
        id={Number(id)}
        handleAddNewLead={handleAddNewLead}
        handleDeleteFile={() => setShowModalDeleteFile(true)}
        handleDeleteLead={(id: number) => {
          setIdLeadDelete(id);
          setShowModalDeleteLead(true);
        }}
        handleAddNewNote={handleAddNewNote}
        handleAddTowYards={handleAddTowYards}
        handleEditNote={handleEditNote}
        handleDeleteTowYards={handleDeleteTowYards}
        handleChangeVinStatus={handleChangeVinStatus}
        handleUploadFileCarfax={handleUploadFileCarfax}
        handleDeleteDocumentLead={handleDeleteDocumentLead}
        handleCloseClient={handleCloseClient}
        handleCloseNotFound={handleCloseNotFound}
      />
      <DialogConfirm
        width={'650px'}
        isOpen={showModalDeleteFile}
        textButton={'Delete'}
        isDelete
        onClose={() => setShowModalDeleteFile(false)}
        textTitle={'Delete File'}
        textContent={
          'Are you sure? Deleting a file will also delete all the photos, documents, and leads associated with the file.'
        }
        onSubmit={handleDeleteFile}
      />
      <DialogConfirm
        width={'650px'}
        isOpen={showModalDeleteLead}
        textButton={'Delete'}
        isDelete
        onClose={() => setShowModalDeleteLead(false)}
        textTitle={'Delete Lead'}
        textContent={'Are you sure? Deleting a lead is permanent.'}
        onSubmit={handleDeleteLead}
      />
    </Stack>
  ) : (
    <LayoutAdminTable
      wrapperProps={{
        style: {
          width: '100%',
          overflow: 'hidden',
          paddingRight: '20px'
        }
      }}
      onClickButton={() => navigate('/admin/files')}>
      <FileForm
        handleChooseRuleOut={handleChooseRuleOut}
        handleRemindLead={handleRemindLead}
        reloadPage={reloadPage}
        handleOnHoldFile={handleOnHoldFile}
        handleDeleteNoteLead={handleDeleteNoteLead}
        optionClient={optionClient}
        optionClientChild={optionClientChild}
        optionAuctionDeliveryLocation={optionAuctionDeliveryLocation}
        changeOptionClient={changeOptionClient}
        initFile={file}
        createForm={asyncUpdateFile}
        isEdit
        leads={leads}
        id={Number(id)}
        handleAddNewLead={handleAddNewLead}
        handleDeleteFile={() => setShowModalDeleteFile(true)}
        handleDeleteLead={(id: number) => {
          setIdLeadDelete(id);
          setShowModalDeleteLead(true);
        }}
        handleAddNewNote={handleAddNewNote}
        handleAddTowYards={handleAddTowYards}
        handleEditNote={handleEditNote}
        handleDeleteTowYards={handleDeleteTowYards}
        handleChangeVinStatus={handleChangeVinStatus}
        handleUploadFileCarfax={handleUploadFileCarfax}
        handleDeleteDocumentLead={handleDeleteDocumentLead}
        handleCloseClient={handleCloseClient}
        handleCloseNotFound={handleCloseNotFound}
      />
      <DialogConfirm
        width={'650px'}
        isOpen={showModalDeleteFile}
        textButton={'Delete'}
        isDelete
        onClose={() => setShowModalDeleteFile(false)}
        textTitle={'Delete File'}
        textContent={
          'Are you sure? Deleting a file will also delete all the photos, documents, and leads associated with the file.'
        }
        onSubmit={handleDeleteFile}
      />
      <DialogConfirm
        width={'650px'}
        isOpen={showModalDeleteLead}
        textButton={'Delete'}
        isDelete
        onClose={() => setShowModalDeleteLead(false)}
        textTitle={'Delete Lead'}
        textContent={'Are you sure? Deleting a lead is permanent.'}
        onSubmit={handleDeleteLead}
      />
    </LayoutAdminTable>
  );
};
